import { render, staticRenderFns } from "./bag-list.vue?vue&type=template&id=51ed8cfd&scoped=true&lang=html"
import script from "./bag-list.vue?vue&type=script&lang=js"
export * from "./bag-list.vue?vue&type=script&lang=js"
import style0 from "./bag-list.vue?vue&type=style&index=0&id=51ed8cfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ed8cfd",
  null
  
)

export default component.exports